import React, { Component } from "react";
import axios from "axios";
import { Table, Button, Modal, Form, Row, Col, Alert } from "react-bootstrap";
import CartContext from "./CartContext";

export default class StorageTankManager extends Component {
  static contextType = CartContext;

  state = {
    storageUnits: [],
    tanks: [],
    partitions: [],

    selectedUnitId: "",
    selectedTankId: "",
    selectedPartitionId: "",

    showUnitModal: false,
    showTankModal: false,
    showPartitionModal: false,

    unitForm: { id: null, unitName: "" },
    tankForm: { id: null, unitId: "", tankCode: "" },
    partitionForm: {
      id: null,
      tankId: "",
      partitionCode: "",
      capacityQty: "",
      isActive: true,
    },

    error: "",
    showUploadModal: false,
    uploadFile: null,
  };

  componentDidMount() {
    this.fetchStorageUnits();
  }

  /* ================= STORAGE UNITS ================= */

  fetchStorageUnits = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_API + "StorageUnit", {
        params: { storeId: this.context.storeId },
      });

      const first = res.data[0];
      this.setState(
        {
          storageUnits: res.data,
          tanks: [],
          partitions: [],
          selectedUnitId: "",
          selectedTankId: "",
          selectedPartitionId: "",
        },
        () => first && this.fetchTanks(first.id),
      );
    } catch {
      this.setState({ error: "Failed to load Storage Units" });
    }
  };

  saveStorageUnit = async () => {
    const { unitForm } = this.state;

    if (unitForm.id) {
      // UPDATE
      await axios.put(
        process.env.REACT_APP_API + "StorageUnit/" + unitForm.id,
        {
          id: unitForm.id,
          unitName: unitForm.unitName,
          storeId: this.context.storeId,
        },
      );
    } else {
      // CREATE
      await axios.post(process.env.REACT_APP_API + "StorageUnit", {
        unitName: unitForm.unitName,
        storeId: this.context.storeId,
      });
    }

    this.fetchStorageUnits();
    this.setState({ showUnitModal: false });
  };

  deleteStorageUnit = async (id) => {
    if (!window.confirm("Delete this Section?")) return;
    await axios.delete(process.env.REACT_APP_API + "StorageUnit/" + id, {
      params: { storeId: this.context.storeId },
    });
    this.fetchStorageUnits();
  };

  /* ================= TANKS ================= */

  fetchTanks = async (unitId) => {
    try {
      const res = await axios.get(process.env.REACT_APP_API + "Tank", {
        params: {
          storeId: this.context.storeId,
          storageUnitId: unitId,
        },
      });

      const first = res.data[0];
      this.setState(
        {
          selectedUnitId: unitId,
          tanks: res.data,
          partitions: [],
          selectedTankId: "",
          selectedPartitionId: "",
        },
        () => first && this.fetchPartitions(first.id),
      );
    } catch {
      this.setState({ error: "Failed to load Tanks" });
    }
  };

  saveTank = async () => {
    const { tankForm } = this.state;

    const payload = {
      unitId: tankForm.unitId,
      tankCode: tankForm.tankCode,
      storeId: this.context.storeId,
    };

    if (tankForm.id)
      await axios.put(process.env.REACT_APP_API + "Tank/" + tankForm.id, {
        ...payload,
        id: tankForm.id,
      });
    else await axios.post(process.env.REACT_APP_API + "Tank", payload);

    this.fetchTanks(tankForm.unitId);
    this.setState({ showTankModal: false });
  };

  deleteTank = async (id) => {
    if (!window.confirm("Delete this Tank?")) return;
    await axios.delete(process.env.REACT_APP_API + "Tank/" + id, {
      params: { storeId: this.context.storeId },
    });
    this.fetchTanks(this.state.selectedUnitId);
  };

  /* ================= PARTITIONS ================= */

  fetchPartitions = async (tankId) => {
    try {
      const res = await axios.get(process.env.REACT_APP_API + "TankPartition", {
        params: {
          storeId: this.context.storeId,
          tankId,
        },
      });

      this.setState({
        selectedTankId: tankId,
        partitions: res.data,
        selectedPartitionId: "",
      });
    } catch {
      this.setState({ error: "Failed to load Partitions" });
    }
  };

  savePartition = async () => {
    const { partitionForm } = this.state;

    const payload = {
      tankId: partitionForm.tankId,
      partitionCode: partitionForm.partitionCode,
      capacityQty: partitionForm.capacityQty,
      isActive: partitionForm.isActive,
      storeId: this.context.storeId,
    };

    if (partitionForm.id)
      await axios.put(
        process.env.REACT_APP_API + "TankPartition/" + partitionForm.id,
        { ...payload, id: partitionForm.id },
      );
    else await axios.post(process.env.REACT_APP_API + "TankPartition", payload);

    this.fetchPartitions(partitionForm.tankId);
    this.setState({ showPartitionModal: false });
  };

  deletePartition = async (id) => {
    if (!window.confirm("Delete this Partition?")) return;
    await axios.delete(process.env.REACT_APP_API + "TankPartition/" + id, {
      params: { storeId: this.context.storeId },
    });
    this.fetchPartitions(this.state.selectedTankId);
  };

  uploadLayout = async () => {
    const { uploadFile } = this.state;
    if (!uploadFile) return;

    const formData = new FormData();
    formData.append("file", uploadFile);

    await axios.post(
      process.env.REACT_APP_API +
        "StorageUnit/Upload?storeId=" +
        this.context.storeId,
      formData,
    );

    this.setState({ showUploadModal: false, uploadFile: null });
    this.fetchStorageUnits();
  };

  printAllPartitionLabels = async () => {
    const api = process.env.REACT_APP_API;
    const storeId = this.context.storeId;

    const width = 50;
    const height = 25;
    const unit = "mm";

    try {
      const tanksRes = await axios.get(api + "Tank/all", {
        params: { storeId },
      });

      const partitionsRes = await axios.get(api + "TankPartition/all", {
        params: { storeId },
      });

      const tanks = tanksRes.data;
      const partitions = partitionsRes.data;
      const units = this.state.storageUnits;

      const labels = [];

      units.forEach((unitObj) => {
        const unitTanks = tanks.filter((t) => t.unitId === unitObj.id);

        unitTanks.forEach((tank) => {
          const tankPartitions = partitions.filter((p) => p.tankId === tank.id);

          tankPartitions.forEach((p) => {
            labels.push({
              barcode: `${unitObj.unitName}${tank.tankCode}${p.partitionCode}`,
              text: `${unitObj.unitName} ${tank.tankCode} ${p.partitionCode}`,
            });
          });
        });
      });

      if (!labels.length) {
        alert("No labels found");
        return;
      }

      const html = `
<!DOCTYPE html>
<html>
<head>

<meta charset="utf-8">

<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>

<style>

@page{
margin:6mm;
}

body{
margin:0;
font-family:Arial;
}

.container{
display:grid;
grid-template-columns: repeat(3, 50mm);
grid-auto-rows: 25mm;
gap:4mm;
justify-content:center;
}

.label{
width:50mm;
height:25mm;
border:1px solid #000;
box-sizing:border-box;

display:flex;
flex-direction:column;
justify-content:center;
align-items:center;

break-inside:avoid;
page-break-inside:avoid;
}

.barcode{
height:14mm;
display:flex;
align-items:center;
justify-content:center;
}

.text{
font-size:13px;
font-weight:bold;
margin-top:1mm;
text-align:center;
}

</style>

</head>

<body>

<div class="container">

${labels
  .map(
    (l, i) => `

<div class="label">

<div class="barcode">
<svg id="bc${i}"></svg>
</div>

<div class="text">
${l.text}
</div>

</div>

`,
  )
  .join("")}

</div>

<script>

${labels
  .map(
    (l, i) => `

JsBarcode("#bc${i}","${l.barcode}",{
format:"CODE128",
width:1.4,
height:40,
margin:0,
displayValue:false
});

`,
  )
  .join("")}

setTimeout(()=>{
window.print();
},300);

</script>

</body>
</html>
`;

      const w = window.open("", "_blank");
      w.document.write(html);
      w.document.close();
    } catch (err) {
      console.error(err);
      alert("Failed to generate labels");
    }
  };

  /* ================= LABEL HELPERS ================= */

  tankLabel = () =>
    this.context.store.businessTypeId === 18 ? "Tank" : "Aisle";

  partitionLabel = () =>
    this.context.store.businessTypeId === 18 ? "Tank Partition" : "Bin";

  /* ================= RENDER ================= */

  render() {
    const {
      storageUnits,
      tanks,
      partitions,
      selectedUnitId,
      selectedTankId,
      unitForm,
      tankForm,
      partitionForm,
      showUnitModal,
      showTankModal,
      showPartitionModal,
      selectedPartitionId,
      error,
    } = this.state;

    return (
      <div className="container mt-2">
        <h5 className="mb-3 fw-bold">Storage Layout</h5>
        <div className="d-flex justify-content-end mb-2">
          <Button
            size="sm"
            variant="outline-dark"
            className="ms-2"
            onClick={this.printAllPartitionLabels}
          >
            🖨 Labels
          </Button>
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() =>
              window.open(
                process.env.REACT_APP_API +
                  "StorageUnit/Download?storeId=" +
                  this.context.storeId,
              )
            }
          >
            ⬇ Download
          </Button>

          <Button
            size="sm"
            variant="outline-success"
            className="ms-2"
            onClick={() => this.setState({ showUploadModal: true })}
          >
            ⬆ Upload
          </Button>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Row>
          {/* SECTIONS */}
          <Col md={4} className="border-end">
            <h6 className="text-muted">Sections</h6>
            <Button
              size="sm"
              className="mb-2"
              onClick={() =>
                this.setState({
                  showUnitModal: true,
                  unitForm: { id: null, unitName: "" },
                })
              }
            >
              + Section
            </Button>

            <Table hover size="sm">
              <tbody>
                {storageUnits.map((u) => (
                  <tr
                    key={u.id}
                    className={
                      selectedUnitId === u.id ? "active-row" : "selectable-row"
                    }
                    onClick={() => this.fetchTanks(u.id)}
                  >
                    <td>{u.unitName}</td>
                    <td className="text-end">
                      <Button
                        size="sm"
                        variant="outline-warning"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({
                            showUnitModal: true,
                            unitForm: {
                              id: u.id,
                              unitName: u.unitName,
                            },
                          });
                        }}
                      >
                        Edit
                      </Button>{" "}
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.deleteStorageUnit(u.id);
                        }}
                      >
                        ✕
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>

          {/* TANKS */}
          <Col md={4} className="border-end">
            <h6 className="text-muted">{this.tankLabel()}s</h6>
            <Button
              size="sm"
              className="mb-2"
              disabled={!selectedUnitId}
              onClick={() =>
                this.setState({
                  showTankModal: true,
                  tankForm: { id: null, unitId: selectedUnitId, tankCode: "" },
                })
              }
            >
              + {this.tankLabel()}
            </Button>

            <Table hover size="sm">
              <tbody>
                {tanks.map((t) => (
                  <tr
                    key={t.id}
                    className={
                      selectedTankId === t.id ? "active-row" : "selectable-row"
                    }
                    onClick={() => this.fetchPartitions(t.id)}
                  >
                    <td>{t.tankCode}</td>
                    <td className="text-end">
                      <Button
                        size="sm"
                        variant="outline-warning"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({
                            showTankModal: true,
                            tankForm: {
                              id: t.id,
                              unitId: t.unitId,
                              tankCode: t.tankCode,
                            },
                          });
                        }}
                      >
                        Edit
                      </Button>{" "}
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.deleteTank(t.id);
                        }}
                      >
                        ✕
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>

          {/* PARTITIONS */}
          <Col md={4}>
            <h6 className="text-muted">{this.partitionLabel()}s</h6>
            <Button
              size="sm"
              className="mb-2"
              disabled={!selectedTankId}
              onClick={() =>
                this.setState({
                  showPartitionModal: true,
                  partitionForm: {
                    id: null,
                    tankId: selectedTankId,
                    partitionCode: "",
                    capacityQty: "",
                    isActive: true,
                  },
                })
              }
            >
              + {this.partitionLabel()}
            </Button>

            <Table hover size="sm">
              <tbody>
                {partitions.map((p) => (
                  <tr
                    key={p.id}
                    className={
                      selectedPartitionId === p.id
                        ? "active-row"
                        : "selectable-row"
                    }
                    onClick={() => this.setState({ selectedPartitionId: p.id })}
                  >
                    <td>{p.partitionCode}</td>
                    <td>{p.capacityQty}</td>
                    <td className="text-end">
                      <Button
                        size="sm"
                        variant="outline-warning"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({
                            showPartitionModal: true,
                            partitionForm: {
                              id: p.id,
                              tankId: p.tankId,
                              partitionCode: p.partitionCode,
                              capacityQty: p.capacityQty,
                              isActive: p.isActive,
                            },
                          });
                        }}
                      >
                        Edit
                      </Button>{" "}
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.deletePartition(p.id);
                        }}
                      >
                        ✕
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* ================= MODALS ================= */}

        {/* Storage Unit Modal */}
        <Modal
          show={showUnitModal}
          onHide={() => this.setState({ showUnitModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Storage Unit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              placeholder="Unit Name"
              value={unitForm.unitName}
              onChange={(e) =>
                this.setState({
                  unitForm: {
                    ...unitForm,
                    unitName: e.target.value,
                  },
                })
              }
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showUnitModal: false })}
            >
              Cancel
            </Button>
            <Button onClick={this.saveStorageUnit}>Save</Button>
          </Modal.Footer>
        </Modal>

        {/* Tank Modal */}
        <Modal
          show={showTankModal}
          onHide={() => this.setState({ showTankModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Tank</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              placeholder="Tank Code"
              value={tankForm.tankCode}
              onChange={(e) =>
                this.setState({
                  tankForm: {
                    ...tankForm,
                    tankCode: e.target.value,
                  },
                })
              }
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showTankModal: false })}
            >
              Cancel
            </Button>
            <Button onClick={this.saveTank}>Save</Button>
          </Modal.Footer>
        </Modal>

        {/* Partition Modal */}
        <Modal
          show={showPartitionModal}
          onHide={() => this.setState({ showPartitionModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Partition</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              className="mb-2"
              placeholder="Partition Code"
              value={partitionForm.partitionCode}
              onChange={(e) =>
                this.setState({
                  partitionForm: {
                    ...partitionForm,
                    partitionCode: e.target.value,
                  },
                })
              }
            />
            <Form.Control
              type="number"
              placeholder="Capacity Qty"
              value={partitionForm.capacityQty}
              onChange={(e) =>
                this.setState({
                  partitionForm: {
                    ...partitionForm,
                    capacityQty: e.target.value,
                  },
                })
              }
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showPartitionModal: false })}
            >
              Cancel
            </Button>
            <Button onClick={this.savePartition}>Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showUploadModal}
          onHide={() => this.setState({ showUploadModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Storage Layout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="file"
              accept=".csv"
              onChange={(e) => this.setState({ uploadFile: e.target.files[0] })}
            />
            <small className="text-muted">
              CSV format: Section, Tank, Partition, CapacityQty, IsActive
            </small>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showUploadModal: false })}
            >
              Cancel
            </Button>
            <Button onClick={this.uploadLayout}>Upload</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showUploadModal}
          onHide={() => this.setState({ showUploadModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Storage Layout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="file"
              accept=".csv"
              onChange={(e) => this.setState({ uploadFile: e.target.files[0] })}
            />
            <small className="text-muted">
              CSV format: Section, Tank, Partition, CapacityQty, IsActive
            </small>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showUploadModal: false })}
            >
              Cancel
            </Button>
            <Button onClick={this.uploadLayout}>Upload</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
